import { useNavigate } from 'react-router-dom';

import { useStatus } from '../hooks/useStatus';
import { Ic } from './Icons';
import { cn } from '../lib/classnames';
import './AppBar.css';

/** Top app bar — three blocks left-to-right:
 *
 *  1. Brand: crosshair-mark glyph (clickable, doubles as the PPP-Online
 *     liveness indicator — green when ``ok``, red when ``down``,
 *     accent-orange when ``unknown``) + "GNSS-QA" wordmark.
 *  2. Scheduler-status: dot + Russian uppercase label
 *     (``РАБОТАЕТ`` / ``ПАУЗА``) — derived from
 *     ``StatusResponse.scheduler_running``.
 *  3. Gear icon → ``/settings`` (a stub in Phase 3.2).
 */
export function AppBar() {
  const { data } = useStatus();
  const navigate = useNavigate();

  const pppStatus = data?.ppp_online_status ?? 'unknown';
  const schedulerRunning = data?.scheduler_running ?? true;
  const schedulerCls = schedulerRunning ? '' : 'paused';
  const schedulerLabel = schedulerRunning ? 'РАБОТАЕТ' : 'ПАУЗА';

  return (
    <div className="appbar">
      <div className="brand">
        <button
          className="brand-mark-btn"
          title={`PPP Online: ${pppStatus}`}
          aria-label={`PPP Online status: ${pppStatus}`}
        >
          <span className={cn('brand-mark', pppStatus)} />
        </button>
        <span className="brand-text">GNSS-QA</span>
      </div>

      <div className={cn('scheduler-status', schedulerCls)}>
        <span className="dot" />
        <span>{schedulerLabel}</span>
      </div>

      <button
        className="icon-btn"
        title="Настройки"
        aria-label="Настройки"
        onClick={() => navigate('/settings')}
      >
        <Ic.gear />
      </button>
    </div>
  );
}
